import React, { Component } from 'react';
import LoadingComponent from '../../components/commonComponents/LoadingComponent';
import CallAPI from '../commonComponents/AxiosHelper';
import Form from '../commonComponents/Form';
import Moment from "moment";
import { extendMoment } from "moment-range";
import ErrorComponent from '../commonComponents/ErrorComponent';
const moment = extendMoment(Moment);


export default class GeneralSettings extends Component {

    constructor(props) {
        super(props);
        this.state = { settings: null , accessError:null }

        this.fetchDefaultSettings = this.fetchDefaultSettings.bind(this);
        this.handleDateFormat = this.handleDateFormat.bind(this);
        this.handleDatasetDate = this.handleDatasetDate.bind(this);
        this.generateSettingForm = this.generateSettingForm.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    fetchDefaultSettings() {
        this.setState({
            settings: null,accessError:null
        });
        let that = this;
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: this.props.datasetValue
        }
        CallAPI('get', '/app/getGeneralSetting', null, params, 0, function (response) {
            checkIfMaintenanceModeOn(response)
            if(response.status!=500){
                
                if(response['data'] !== "error"){
                    that.setState({ settings: response['data'][0] })
                }
                else{
                    that.setState({ settings: response['data']})
    
                }
            }else{
                that.setState({
                    accessError : true
                })
            }
        }, this.props.authData)
    }

    componentWillMount() {
        this.fetchDefaultSettings();
    }

    componentDidUpdate(prevProps, nextState) {
        let that = this;
        if (prevProps.datasetValue !== this.props.datasetValue) {
            this.setState({
                settings: null
            })
            this.fetchDefaultSettings();
        }
    }
    onSubmit(e) {
        e.preventDefault();
        let setting_form_array = jQuery("#setting_form_data").serializeArray();
        let setting_data = {};
        let that = this;
        // {"access":[{"userType":1}}

        setting_form_array.map(function (element, i) {
            setting_data[element.name] = element.value;
        });

        const keysToRemove = ["status", "startDate", "endDate"];
        setting_data['maintenance'] = { 'status': setting_data['status'], 'startTime': setting_data['startDate'].replace("T", " "), 'endTime': setting_data['endDate'].replace("T", " ") }

        setting_data['share_enable'] = { "access": [{ "userType": setting_data['share_enable'] }] };

        let calculated = that.handleDatasetDate(setting_data['dashboardStartTime'], setting_data['dashboardEndTime']);

        const updatedSettingsData = Object.fromEntries(Object.entries(setting_data).filter(([key, value]) => !keysToRemove.includes(key)));

        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: that.props.datasetValue
        }

        if (calculated) {
            if (confirm("Please Confirm to Update.")) {
                CallAPI('post', '/app/setGeneralSetting', updatedSettingsData, params, 0, function (response) {
                    alert("Settings uploaded successfully.");
                    that.fetchDefaultSettings();
                }, that.props.authData);
            }
        } else {
            alert('Dataset Start Date cannot be greater than Dataset End Date');
        }
    }

    handleDateFormat(date) {
        return moment(date).format('YYYY-MM-DD');
    }

    handleDatasetDate(startDate, endDate) {
        return startDate > endDate ? false : true;
    }

    generateSettingForm() {
        try {

            let parsedValue = JSON.parse(this.state.settings.maintenance)
            let share_enable_value = JSON.parse(this.state.settings.share_enable)['access'][0]['userType'] != undefined ? (JSON.parse(this.state.settings.share_enable)['access'][0]['userType']).toString() :"";
            let information = this.state.settings != null && this.state.settings?.information ? JSON.parse(this.state.settings?.information) : null
            let trendHoverInfo = information != null && information?.['trend_hover_information'] != undefined ? information?.['trend_hover_information'] : 'growth'
            let tooltipConfig = information != null && information?.['tooltip_config'] != undefined ? information?.['tooltip_config'] : 'all'
            let alfredConfig = information != null && information?.['alfred_config'] != undefined ? information?.['alfred_config'] : 'no'
            let maintainAlfredDate = information != null && information?.['maintainAlfredDate'] != undefined ? information?.['maintainAlfredDate'] : 'true'


            let metricUnitPlacement = information != null && information?.['metricUnitPlacement'] != undefined ? information?.['metricUnitPlacement'] : '0'
            let startOfWeek = information != null && information?.['startOfWeek'] != undefined ? information?.['startOfWeek'] : '1' 
            let displayDimensionFilterValue = information != null && information?.['displayDimensionFilter'] != undefined ? information?.['displayDimensionFilter'] : true

            var settingFormData = {
                // "financialYear": {
                //     "name": "financialYear", "label": "Financial Year", "type": "dropdown", "text_value": "", "options": [
                //         { "name": "Yes", "value": 1 },
                //         { "name": "No", "value": 0 },
                //     ],
                // },
                "FYMonthStart": {
                    "name": "FYMonthStart", "label": "Start of Fiscal Year", "type": "dropdown", "text_value": this.state.settings.FYMonthStart, "options": [
                        { "name": "Not Applicable", "value": "0" },
                        { "name": "January", "value": "1" },
                        { "name": "February", "value": "2" },
                        { "name": "March", "value": "3" },
                        { "name": "April", "value": "4" },
                        { "name": "May", "value": "5" },
                        { "name": "June", "value": "6" },
                        { "name": "July", "value": "7" },
                        { "name": "August", "value": "8" },
                        { "name": "September", "value": "9" },
                        { "name": "October", "value": "10" },
                        { "name": "November", "value": "11" },
                        { "name": "December", "value": "12" },
                    ],
                },
                "startOfWeek": {
                    "name": "startOfWeek", "label": "Start of a Week", "type": "dropdown", "text_value": startOfWeek, "options": [
                        { "name": "Sunday", "value": "0" },
                        { "name": "Monday", "value": "1" },
                        { "name": "Tuesday", "value": "2" },
                        { "name": "Wednesday", "value": "3" },
                        { "name": "Thursday", "value": "4" },
                        { "name": "Friday", "value": "5" },
                        { "name": "Saturday", "value": "6" }
                    ],
                },
                "displayDimensionFilter": {
                    "name": "displayDimensionFilter", "label": "Display Dimensions Filter on Dashboard", "type": "dropdown", "text_value": displayDimensionFilterValue, "options": [
                        { "name": "Yes", "value": true },
                        { "name": "No", "value": false },
                    ],
                },
                "dashboardStartTime": {
                    "name": "dashboardStartTime", "label": "Dashboard Start Date", "type": "date",
                    "text_value": this.handleDateFormat(this.state.settings.dashboardStartTime)
                    , "min": this.handleDateFormat(this.state.settings.startTime), "max": this.handleDateFormat(this.state.settings.endTime)
                },
                "dashboardEndTime": {
                    "name": "dashboardEndTime", "label": "Dashboard End Date", "type": "date",
                    "text_value": this.handleDateFormat(this.state.settings.dashboardEndTime), "min": this.handleDateFormat(this.state.settings.startTime), "max": this.handleDateFormat(this.state.settings.endTime)
                },
                // },
                "share_enable": {
                    "name": "share_enable", "label": "Dashboard Share Access", "type": "dropdown", "text_value": share_enable_value, "options": [
                        { "name": "All Users", "value": "all" },
                        { "name": "Admin Users", "value": "1" },
                        { "name": "Read Only Users", "value": "3" },
                    ],
                },
                "defaullt_landing_page": {
                    "name": "defaullt_landing_page", "label": "Default Landing Page", "type": "dropdown", "text_value": this.state.settings.defaullt_landing_page, "options": [
                        { "name": "Alfred", "value": "alfred" },
                        { "name": "Summary", "value": "summary" },
                        { "name": "Dashboard", "value": "dashboard" },
                        { "name": "Report", "value": "report" }
                    ]
                },
                "filter_switch_flag": {
                    "name": "filter_switch_flag", "label": "Open Filter By Default", "text_value": this.state.settings.filter_switch_flag, "type": "dropdown", "options": [
                        { "name": "Yes", "value": 1 },
                        { "name": "No", "value": 0 },
                    ],
                },
                "maintainAlfredDate": {
                    "name": "maintainAlfredDate", "label": "Maintain Alfred Date", "text_value": maintainAlfredDate, "type": "dropdown", "options": [
                        { "name": "True", "value": "true" },
                        { "name": "False", "value": "false" },
                    ],
                },
                "dataLabels": {
                    "name": "dataLabels", "label": "Enable Data Labels", "text_value": this.state.settings.dataLabels, "type": "dropdown", "options": [
                        { "name": "Yes", "value": 1 },
                        { "name": "No", "value": 0 },
                    ],
                },
                "showChartSummary": {
                    "name": "showChartSummary", "label": "Enable Summary On Chart", "text_value": this.state.settings.showChartSummary, "type": "dropdown", "options": [
                        { "name": "Yes", "value": 1 },
                        { "name": "No", "value": 0 },
                    ],
                },
                "IgnoreZeroInResult": {
                    "name": "IgnoreZeroInResult", "label": "Ignore Blank Values In Data", "text_value": this.state.settings.IgnoreZeroInResult, "type": "dropdown", "options": [
                        { "name": "Yes", "value": 1 },
                        { "name": "No", "value": 0 },
                    ],
                },
                "growthCompareTo": {
                    "name": "growthCompareTo", "label": "Set Growth Period", "text_value": this.state.settings.growthCompareTo, "type": "dropdown", "options": [
                        { "name": 'Previous period', "value": '0' },
                        { "name": 'Same Period In Previous Week', "value": '1' },
                        { "name": 'Same Period In Previous Month', "value": '2' },
                        { "name": 'Same Period In Previous Year', "value": '3' }
                    ],
                },
                "showChartSummary": {
                    "name": "showChartSummary", "label": "Enable Summary On Chart", "text_value": this.state.settings.showChartSummary, "type": "dropdown", "options": [
                        { "name": "Yes", "value": 1 },
                        { "name": "No", "value": 0 },
                    ],
                },
                    "filterInformation": {
                        "name": "filterInformation", "label": "Filter Information", "text_value": information?.['filterInformation'], "type": "dropdown", "options": [
                        { "name": "Old", "value": 1 },
                        { "name": "New", "value": 0 },
                    ],
                },
                "alfredLimitToShowBarChart": {
                    "name": "alfredLimitToShowBarChart", "label": "Change From Table To Bar Chart On", "text_value": this.state.settings.alfredLimitToShowBarChart, "type": "number"
                },
                "last_row_function_min_month": {
                    "name": "last_row_function_min_month", "label": "Minimum Months To Apply Row Function", "text_value": this.state.settings.last_row_function_min_month, "type": "number"
                },
                "tooltip_config": {
                    'name': 'tooltip_config', 'label': 'Configure Tooltip on Charts', 'text_value': tooltipConfig, 'type': 'dropdown', 'options': [
                        { "name": 'Single Metric', "value": "single" },
                        { "name": 'All Selected Metrics', "value": "all" }
                    ]
                },
                "alfred_config": {
                    'name': 'alfred_config', 'label': 'Configure Alfred Query Persist', 'text_value': alfredConfig, 'type': 'dropdown', 'options': [
                        { "name": 'Yes', "value": "yes" },
                        { "name": 'No', "value": "no" }
                    ]
                },
                "metricUnitPlacement": {
                    "name": "metricUnitPlacement", "label": "Metric Unit placement (Table)", "text_value": metricUnitPlacement, "type": "dropdown", "options": [
                        { "name": 'Select Unit Placement', "value": "" },
                        { "name": 'with Header', "value": "1" },
                        { "name": 'with Values', "value": "0" },
                    ], "requiredFlag": true
                },
                "trend_hover_information": {
                    "name": "trend_hover_information", "label": "Trend Hover Information (Time Series Chart)", "text_value": trendHoverInfo, "type": "dropdown", "options": [
                        { "name": 'Growth', "value": "growth" },
                        { "name": 'Variance', "value": "variance" },
                    ], "requiredFlag": true
                },
                'db_to_use': {
                    'name': 'db_to_use', 'label': 'Compute Engine', 'text_value': db_to_use, 'type': 'dropdown', 'options': [
                        { "name": 'Select Compute Engine', "value": "" },
                        { "name": 'MySQL', "value": "mysql" },
                        { "name": 'Clickhouse', "value": "clickhouse" },
                    ]
                },
                "enableMaintenance": {
                    "name": "status", "label": "Enable Maintenance", "text_value": parsedValue.status, "type": "dropdown", "options": [
                        { "name": "Enable", "value": 'enable' },
                        { "name": "Disable", "value": 'disable' },
                    ],
                },
                "maintenanceStartDate": {
                    "name": "startDate", "label": "Maintenance Start Date/Time", "type": "datetime-local",
                    "text_value": parsedValue.startTime, "min": this.handleDateFormat(parsedValue.startTime), "max": this.handleDateFormat(parsedValue.endTime)

                },
                "maintenanceEndDate": {
                    "name": "endDate", "label": "Maintenance End Date/Time", "type": "datetime-local",
                    "text_value": parsedValue.endTime,
                    "min": this.handleDateFormat(parsedValue.startTime), "max": this.handleDateFormat(parsedValue.endTime)
                }



            };

            var body = <Form label_array={settingFormData} call_back={this.call_back_form} />;
            return body;
        }
        catch (e) {
            return "error";
        }
    }

    render() {

        var body = this.state.accessError ? <div className="d-flex">
            <div class="alert alert-danger h-25 mg-b-0" role="alert"><i data-feather="alert-circle" class="mg-r-10"></i>
                This dataset don’t have admin access. Kindly provide admin access. <a href="/admin/useraccess" class="alert-link" target="_blank">Click here for grant permission</a>
            </div>
        </div> : <LoadingComponent />;
        let errorBody = null;
        if (this.state.settings !== null) {
            if (this.state.settings !== "error") {
                body = this.generateSettingForm();
            }
            else {
                body = null;
                errorBody = <div className="d-flex justify-content-center"><ErrorComponent /></div>;
            }
        }



        return (
            <div id="main-content" className='wd-250'>
                <div className="form-group row ">
                    <form autoComplete="off" onSubmit={this.onSubmit} id="setting_form_data" className='mg-l-5'>
                    
                        {(body?.props.label_array !== undefined && body?.props.label_array !== null) ? <>
                            {body}
                            {console.log(body)}
                            {<div className='row pd-x-12'><button id="saveButton" name="property" className='w-100 btn btn-sm btn-primary mg-y-5' type="submit">Save</button></div>}
                        </> : null}

     
                    </form>
                </div>
                {(errorBody !== undefined && errorBody !== null) ? errorBody : null}

            </div>
        );
    }
};

